import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';

export default function useGetElementHeight(selector: string) {
  const theme = useTheme();
  const [elemHeight, setElemHeight] = useState<number | undefined>();

  useEffect(() => {
    const handleResize = () => {
      setElemHeight(document.getElementById(selector)?.clientHeight);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [theme, selector]);

  useEffect(() => setElemHeight(document.getElementById(selector)?.clientHeight), [selector]);

  return elemHeight;
}
